export default __webpack_public_path__ + "static/media/img1.ed70b171.jpg";